/**
 * @desc 导出年计划概览
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanExportOverviewRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/plan/year/exportPlanOverview',
    data,
  });
}

export function mock(
  data: defs.PlanExportOverviewRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/plan/year/exportPlanOverview',
    data,
  });
}
